import { Dispatch } from 'redux';
import { Officer } from '../../pages/arc/features/institution-officers/institution-officers-models';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';

export const getOfficersList = (institutionGuid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.wam}/organizations/${institutionGuid}/admins`,
		onSuccess,
		onFailure,
	});
};

export const getGroupAdminsList = (institutionClientNumber, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.wam}/groups/${institutionClientNumber}/admins`,
		onSuccess,
		onFailure,
	});
};



export const reInviteOfficerOrAdmin = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.wam}/people/${guid}/invitations/re_invite`,
		onSuccess,
		onFailure,
	});
};

const getRemoveOfficerPayload = (officer: Officer, rolesToRemove: string[]) => {

	const keys = Object.keys(officer?.roles);
	const roleObjects = keys?.filter(k => rolesToRemove?.includes(officer?.roles[k]?.role_name))?.map(roleName => { return { appName: roleName, role: officer?.roles[roleName] }; });

	const payload: any = {
		role_assignments: {

		},
	};

	roleObjects?.forEach(roleToRomove => {
		payload.role_assignments[roleToRomove?.appName] = [
			{
				id: roleToRomove?.role?.role_assignment_id,
				deleted: true,
				role: roleToRomove?.role?.role_name,
				institution: { client_number: roleToRomove?.role?.role_target },
			},
		];
	});

	return payload;

};

export const removeOfficer = (officer: Officer, rolesToRemove: string[], onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.wam}/people/${officer.guid}/role_assignments/user`,
		payloadData: getRemoveOfficerPayload(officer, rolesToRemove),
		onSuccess,
		onFailure,
	});
};
export function postSponsoredRoleAssignment(payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.wam}/role_assignments/create_new_user`,
		payloadData,
		onSuccess,
		onFailure,
	});
}

export function postNonSponsoredRoleAssignment(personGuid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.wam}/people/${personGuid}/role_assignments/user`,
		payloadData,
		onSuccess,
		onFailure,
	});
}


export function getRoles(personGuid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.wam}/people/${personGuid}/role_assignments`,
		onSuccess,
		onFailure,
	});
}

export function getApplications(onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.wam}/applications`,
		onSuccess,
		onFailure,
	});
}


export const getDioceseList = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.wam}/diocese_info`,
		onSuccess,
		onFailure,
	});
};